import React from "react";
import Pagination from "../components/blogs/Pagination";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import BlogCardUsuarios from "../components/blogs/BlogCardUsuarios"

export default function BlogUsuarios() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        HeaderTitle="Ayuda para Usuarios"
        Parent="Ayuda"
        PageTitle="Guias de Uso"
      />
      <BlogCardUsuarios />
      <Pagination hasBg />
      <Footer />
    </Layout>
  );
}
